import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const getQuarterNameByQuarterStartMonth = (
  month: number,
  quarterStartMonth?: number,
) => {
  if (!quarterStartMonth) {
    return;
  }

  const { quarter } = getFQuarterByStartMonth(month + 1, quarterStartMonth);

  return `Q${quarter}`;
};
